import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Rol } from 'src/app/core/models/rol/rol';
import { Sucursal } from 'src/app/core/models/sucursal/sucursal';
import {
	ApiResponse,
	BaseHttpService
} from 'src/app/core/services/base-http.service';
import { environment } from 'src/environments/environment';
import { Usuario } from 'src/app/core/models/usuario/usuario';
import { UsuarioEmpresaRol } from 'src/app/core/models/usuario/usuario-empresa-rol';
import { UsuarioEmpresaSucursal } from 'src/app/core/models/usuario/usuario-empresa-sucursal';
import { UsuarioBase } from 'src/app/core/models/usuario/usuario-base';
import { CreateUsuario } from 'src/app/core/models/usuario/create-usuario';

@Injectable({
	providedIn: 'root'
})
export class UserService extends BaseHttpService<
	UsuarioBase,
	Usuario,
	CreateUsuario
> {
	constructor(http: HttpClient) {
		super(http);
		this.url = 'Usuarios';
		this.baseUrl = environment.apiUrl;
	}

	sessionEmpresa(): Observable<any> {
		return this.http.get<any>(`${this.baseUrl}/${this.url}/Session/Empresas`);
	}

	sessionRolesPermisos(): Observable<{ data: Rol[] }> {
		return this.http.get<{ data: Rol[] }>(
			`${this.baseUrl}/${this.url}/Session/RolesPermisos`
		);
	}

	createCompanyRole(
		data: UsuarioEmpresaRol[],
		idUser: number
	): Observable<UsuarioEmpresaRol[]> {
		return this.http.post<UsuarioEmpresaRol[]>(
			`${this.baseUrl}/${this.url}/${idUser}/Roles`,
			data
		);
	}

	createUserBranch(
		idUser: number,
		data: UsuarioEmpresaSucursal
	): Observable<number[]> {
		return this.http.post<number[]>(
			`${this.baseUrl}/${this.url}/${idUser}/Sucursales`,
			data
		);
	}

	deleteUserBranch(
		idUser: number,
		data: { empresas: { idEmpresa: number }[] }
	): Observable<boolean> {
		return this.http.put<boolean>(
			`${this.baseUrl}/${this.url}/${idUser}/Sucursales`,
			data
		);
	}

	getCompanyRole(idUser: number): Observable<EmpresaRolDesc[]> {
		return this.http.get<EmpresaRolDesc[]>(
			`${this.baseUrl}/${this.url}/${idUser}/Roles`
		);
	}

	getUserBranches(
		idUser: number,
		filters?: any
	): Observable<ApiResponse<Sucursal>> {
		const queryParams =
			filters != undefined ? this.setQueryParams(filters) : undefined;
		return this.http.get<ApiResponse<Sucursal>>(
			`${this.baseUrl}/${this.url}/${idUser}/Sucursales${queryParams != undefined ? queryParams : ''}`
		);
	}

	existeCuil(cuil: string): Observable<boolean> {
		return this.http.get<boolean>(
			`${this.baseUrl}/${this.url}/ExisteCUIL/${cuil}`
		);
	}
	existeMail(mail: string, filter?: any): Observable<ApiResponse<any>> {
		const queryParams =
			filter != undefined ? this.setQueryParams(filter) : undefined;
		return this.http.get<ApiResponse<any>>(
			`${this.baseUrl}/${this.url}/ExisteMail/${mail}${queryParams != undefined ? queryParams : ''}`
		);
	}
	habilitarUsuario(
		idUser: number,
		habilita: boolean,
		data: CreateUsuario
	): Observable<Usuario> {
		return this.http.patch<Usuario>(
			`${this.baseUrl}/${this.url}/${idUser}/Habilitado/${habilita}`,
			data
		);
	}
	reenviarLinkInvitacion(idUser: number, data: Usuario): Observable<Usuario> {
		return this.http.post<Usuario>(
			`${this.baseUrl}/${this.url}/ReenviarLinkInvitacion/${idUser}`,
			data
		);
	}
	existeRegistroB2C(idUser: number): Observable<boolean> {
		return this.http.get<boolean>(
			`${this.baseUrl}/${this.url}/ExisteRegistroB2C/${idUser}`
		);
	}
}

export interface EmpresaRolDesc {
	empresa: { id: number; razonSocial: string };
	roles: Rol[];
}
